// 0=下载，1=暂停
const startDownloadCode = 0;
const pauseDownloadCode = 1;
const SparkAppStatusProgress = 'progress';
const SparkAppStatusWait = 'wait';
const SparkAppStatusPause = 'pause';
const SparkAppStatusInstall = 'install'; //  准备安装
const SparkAppStatusFinish = 'finish';
const SparkAppStatusUndownload = 'undownload'; // 未开始下载
let downProcess = 0;// 存储暂停的显示下载进度
function HandleSparkAppClientDownload() {
  this.gameInfo = {};
  this.getChannel =  () => '10058448';
  this.iosDownLoadGameInfo = {};
  this.getStatusCode = (status) => {
    const mapping = {
      [SparkAppStatusWait]: 1,
      [SparkAppStatusWait]: 1,
      [SparkAppStatusProgress]: 2,
      [SparkAppStatusPause]: 3,
      [SparkAppStatusFinish]: 99,
      [SparkAppStatusInstall]: 4,
      [SparkAppStatusUndownload]: 0,
    };
    return mapping[status] || 0;
  };
  this.setGameInfo = (GameInfos) => {
    const {
      game_name: gameName, version,
      android_pkg_name: androidPkgName, ios_pkg_name: iosPkgName, ios_download_url: iosDownloadUrl,
      android_download_url: androidDownloadUrl, ios_url_scheme: iosUrlScheme,
      icon, apk_md5: md5, package_size: packageSize, game_code: gameCode, android_cdn_channels: androidCdnChannels = {},
    } = GameInfos || {};
    const  params = {
      iconUrl: icon,
      url: androidDownloadUrl,
      packageName: androidPkgName,
      appName: gameName,
      versionCode: version,
      packageSize,
      // 标志位，默认自动下载安装。 bit0 是否自动安装，bit1是否强制wifi, bit2是否检查wifi，bit3是否在任务栏提示,bit4是否回调下载信息,bit5是否校验安装包签名信息,bit6是否静默下载
      // eslint-disable-next-line no-restricted-properties
      flags: Math.pow(2, 3) +  Math.pow(2, 4) +  Math.pow(2, 6) + Math.pow(2, 0),
      mExtData: {
        gameCode,
        apkMd5: md5,
      },
    };
    // 有特定渠道
    const specialChannel  = androidCdnChannels[this.getChannel()];
    if (specialChannel && typeof specialChannel === 'object') {
      if  (specialChannel.download_url) {
        params.url = specialChannel.download_url;
      }
      if  (specialChannel.file_size) {
        params.packageSize = specialChannel.file_size;
      }
      if  (specialChannel.md5) {
        params.mExtData.apkMd5 = specialChannel.md5;
      }
    }
    this.iosDownLoadGameInfo = {
      iosurl: iosDownloadUrl,
      iosPkgName,
      scheme: iosUrlScheme,
    };
    this.gameInfo = params;
    console.log('-----HandleSparkAppClientDownload this.gameInfo =----', this.gameInfo);
    return params;
  };
  // 审批不显示
  this.isShowDownloadComponent =  () => !window.SX_WEB.tool.env.isSwitchOn;
  this.doDownloadInIOS = () =>  {
    console.log('--------------doDownloadInIOS -this.iosDownLoadGameInfo=', this.iosDownLoadGameInfo);
    if (window.SX_WEB.tool.env.ios) {
      window.SX_WEB.jsBridge.app.launchApp({
        downloadUrl: this.iosDownLoadGameInfo.iosurl,
        scheme: this.iosDownLoadGameInfo.iosUrlScheme,
      });
    }
  };
  /**
   *
   * @param callback
   * @param pauseImmediate  为实现一进页面获取暂停的下载进度，需要马上关闭下载
   */
  this.startDownload = (callback, pauseImmediate) => {
    console.log('--------------startDownload -this.gameInfo=', this.gameInfo);
    const that = this;
    window.SX_WEB.jsBridge.app.downloadApk({
      actionCode: startDownloadCode,
      ...this.gameInfo,
      callback: async (res) => {
        console.log('startDownload spark callback', res);
        // ############### 闪现app 进入模拟查询下载进度|重新触发app安装---》避免触发重新下载
        if  (pauseImmediate === true && res.type === SparkAppStatusProgress) {
          console.log('startDownload pauseImmediate spark callback', res);

          that.stopDownloadApp();
          const { progress = 0 } = res;
          let type = SparkAppStatusPause;
          if (progress <=  1) {
            type = SparkAppStatusUndownload;
          }
          if (typeof  callback === 'function') {
            const  simulateInfo = that.getSimulateInfo({ ...res, type });
            callback(simulateInfo);
          }
          return;
        }
        // ###############
        if (typeof  callback === 'function') {
          const simulateInfo = that.getSimulateInfo(res);
          console.log('getSimulateInfo =', simulateInfo);
          callback(simulateInfo);
        }
      },
    });
  };
  //  需要模拟下载进度 显示已下载大小
  this.getSimulateInfo = ({ type = 'progress', progress = 0 }) => {
    const  packageSize = parseInt(this.gameInfo.packageSize, 10);
    if (progress > 0) {
      downProcess = progress;
    }
    const res =  {
      totalLen: packageSize,
      receivedLen: 0,
      state: this.getStatusCode(type),
    };
    if (type === SparkAppStatusPause && downProcess > 0) {
      res.receivedLen = parseInt(downProcess / 100 * packageSize, 10);
      return res;
    }
    res.receivedLen =  progress > 0 ?   parseInt(progress / 100 * packageSize, 10) : 0;
    return res;
  };
  this.checkDownloadState = (callback) => {
    console.log('--------------checkDownloadState -this.gameInfo=', this.gameInfo);
    this.startDownload(callback, true);
  };
  // 暂停
  this.stopDownloadApp = (callback) => {
    console.log('android stopDownloadApp spark ',  this.gameInfo);
    const that = this;
    window.SX_WEB.jsBridge.app.downloadApk({
      actionCode: pauseDownloadCode,
      ...this.gameInfo,
      callback: async (res) => {
        console.log('stopDownloadApp spark callback', res);
        if (typeof  callback === 'function') {
          const  simulateInfo = that.getSimulateInfo(res);
          console.log('getSimulateInfo =', simulateInfo);
          callback(simulateInfo);
        }
      },
    });
  };
  this.isAppInstalled = async () => await  window.SX_WEB.jsBridge.app.isAppInstalled({
    identifier: this.gameInfo.packageName,
  });
  this.installGame = () => {
    console.log('android installGame spark ',  this.gameInfo);
    this.startDownload(null, true);//  实现点击触发按钮s
  };
  this.callGame = () => {
    console.log('android callGame spark ',  this.gameInfo.packageName);
    window.SX_WEB.jsBridge.app.launchApp({
      identifier: this.gameInfo.packageName,
    }).then((res) => {
      console.log('launchApp res', res);
    });
  };
  this.beforeDownloadCheck = () => '';
  this.getAppVersion = function () {
    const str = navigator.userAgent.toLowerCase();
    if (!str) {
      return '';
    }
    if (str.match('com.tencent.gamecommunity') === null) {
      return '';
    }
    const reg = new RegExp('VERSION_NAME/([0-9.]+)');
    const res  = str.match(reg);
    if (!res || !res[1]) {
      return '';
    }
    if (!res[1] instanceof Array || res[1].length === 0) {
      return  '';
    }
    return  res[1];
  };
  this.needReportDownloadPause  = true;
  this.needReportDownloadFinish  = true;
  this.needReportInstallGame  = true;
  this.needReportlaunchGame  = true;
  console.log('---------------------init done HandleSparkAppClientDownload');
  return this;
};

export  default  HandleSparkAppClientDownload;
export { HandleSparkAppClientDownload };
